module.exports = __webpack_public_path__ + "img/sand-rock-big-06.5c1e4e00.png";